import React from 'react';
import {List} from 'components';
import {User} from 'api/types/userTypes';

type UserListProps = {
  data?: User[];
  count?: number;
  onClick: (id?: string) => () => void;
  className?: string;
  showOrganization?: boolean;
};

function UserList({data, onClick, className, showOrganization}: UserListProps) {
  const items = data
    ? data.map(
        ({name, email, id, organization: {name: organizationName} = {}}) => ({
          title: name,
          id: id,
          subtitle: email,
          onClick: onClick(id),
          flag:
            showOrganization && organizationName ? organizationName : undefined,
        })
      )
    : [];

  return (
    <div className={`${className || ''} overflow-scroll`}>
      <div className="w-full xl:w-7/12 m-auto p-4">
        <List className="w-full py-2">
          {items.map(item => (
            <List.Item data={item} key={item.id} />
          ))}
        </List>
      </div>
    </div>
  );
}

export default UserList;
